module.exports = __webpack_public_path__ + "/content/skins/volvo/fav/apple-touch-icon-76x76.png";